import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CrudService } from '../services/crud.service';
import { MonthlySummaryResponse, ProductBreakdownResponse } from './effectiveness.models';
import notify from 'devextreme/ui/notify';

@Injectable({ providedIn: 'root' })
export class EffectivenessService {

  private apiUrl = environment.baseApiUrl;

  constructor(private crudService: CrudService) {}

  loadMonthlySummary(
    startDate: string,
    endDate: string,
    buyingGroup?: number | null,
    promotionType?: string | null
  ): Promise<MonthlySummaryResponse | null> {
    let url = `${this.apiUrl}effectiveness/monthly-summary?start_date=${startDate}&end_date=${endDate}`;
    if (buyingGroup !== null && buyingGroup !== undefined) {
      url += `&buying_group=${buyingGroup}`;
    }
    if (promotionType !== null && promotionType !== undefined) {
      url += `&promotion_type=${encodeURIComponent(promotionType)}`;
    }

    return new Promise((resolve) => {
      this.crudService.getData(url).subscribe({
        next: (result: any) => {
          if (result.success) {
            resolve(result.data as MonthlySummaryResponse);
          } else {
            notify(result.message || 'Failed to load monthly summary', 'error', 6000);
            resolve(null);
          }
        },
        error: () => {
          notify('Failed to load monthly summary', 'error', 6000);
          resolve(null);
        }
      });
    });
  }

  loadPromotionBreakdown(promotionId: number): Promise<ProductBreakdownResponse | null> {
    const url = `${this.apiUrl}effectiveness/promotion-breakdown?promotion_id=${promotionId}`;
    return new Promise((resolve) => {
      this.crudService.getData(url).subscribe({
        next: (result: any) => {
          if (result.success) {
            resolve(result.data as ProductBreakdownResponse);
          } else {
            notify(result.message || 'Failed to load product breakdown', 'error', 6000);
            resolve(null);
          }
        },
        error: () => {
          notify('Failed to load product breakdown', 'error', 6000);
          resolve(null);
        }
      });
    });
  }

  loadBuyingGroups(): Promise<any[]> {
    const url = `${this.apiUrl}buying-groups`;
    return new Promise((resolve) => {
      this.crudService.getData(url).subscribe({
        next: (result: any) => {
          if (Array.isArray(result)) {
            resolve(result);
          } else if (result?.data && Array.isArray(result.data)) {
            resolve(result.data);
          } else {
            resolve([]);
          }
        },
        error: () => {
          notify('Failed to load buying groups', 'error', 6000);
          resolve([]);
        }
      });
    });
  }

  loadPromotionTypes(): Promise<any[]> {
    const url = `${this.apiUrl}promotion-types`;
    return new Promise((resolve) => {
      this.crudService.newGetData(url).subscribe({
        next: (result: any) => {
          if (Array.isArray(result)) {
            resolve(result);
          } else if (result?.data && Array.isArray(result.data)) {
            resolve(result.data);
          } else {
            resolve([]);
          }
        },
        error: () => {
          notify('Failed to load promotion types', 'error', 6000);
          resolve([]);
        }
      });
    });
  }
}
